// Generic form helpers — auto-initialized on any page.
//
// `data-visibility-form` on a <form>: pairs with `data-visibility-mode-select`
//   (a <select> with values matching {:always, :never, :date}) and
//   `data-visibility-date-fields` (the wrapping element of the date inputs);
//   toggles `.has-hidden` on the date fields when the select is not "date".
//
// `data-save-on-change-form` on a <form>: pairs with `data-save-on-change-button`
//   on a button inside it. The button gets the `has-hidden` class unless any
//   input/textarea/select inside the form differs from its initial value.
//
// `data-toggle-select` on a <select>: on change, every `data-toggle-when` element inside its
//   `data-toggle-scope` ancestor gets `has-hidden` and `disabled` unless the select holds its value.
//   The initial state is the server's to render. `disabled` too, so a hidden `required` input cannot
//   block the submit of a form it is no longer part of.
//
// `data-toggle-checkbox` on a checkbox: same, for every `data-toggle-checked` element inside its
//   `data-toggle-scope` ancestor, shown only while the box is ticked. Reach for it when the gated
//   fields sit in several sections; a single block is better served by `collapsible_fieldset`.

import { toggleScope } from "./toggle_scope";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-visibility-form]").forEach((form) => {
    const select = form.querySelector("[data-visibility-mode-select]");
    const dateFields = form.querySelector("[data-visibility-date-fields]");
    if (!select || !dateFields) return;
    select.addEventListener("change", () => {
      dateFields.classList.toggle("has-hidden", select.value !== "date");
    });
  });

  document.querySelectorAll("[data-save-on-change-form]").forEach((form) => {
    const button = form.querySelector("[data-save-on-change-button]");
    if (!button) return;

    const inputs = form.querySelectorAll("input, textarea, select");
    const initial = Array.from(inputs).map(fieldValue);

    const sync = () => {
      const modified = Array.from(inputs).some((el, i) => fieldValue(el) !== initial[i]);
      button.classList.toggle("has-hidden", !modified);
    };

    inputs.forEach((el) => {
      el.addEventListener("input", sync);
      el.addEventListener("change", sync);
    });
    sync();
  });

  // Bound on the form, not the select: Vue re-renders the program and block forms' inner DOM on
  // mount, which would orphan a listener bound to the select itself. The form element survives.
  document.querySelectorAll("[data-toggle-select]").forEach((select) => {
    select.form.addEventListener("change", ({ target }) => {
      if (!target.matches("[data-toggle-select]")) return;

      toggleScope(target, "[data-toggle-when]", (el) => el.dataset.toggleWhen === target.value);
    });
  });

  document.querySelectorAll("[data-toggle-checkbox]").forEach((checkbox) => {
    checkbox.form.addEventListener("change", ({ target }) => {
      if (!target.matches("[data-toggle-checkbox]")) return;

      // Every `[data-toggle-checked]` of the scope follows this one box, so a second
      // `data-toggle-checkbox` in the same scope would fight it over the same elements.
      toggleScope(target, "[data-toggle-checked]", () => target.checked);
    });
  });
});

function fieldValue(el) {
  if (el.type === "checkbox" || el.type === "radio") return el.checked;
  return el.value;
}
